module.exports = __webpack_public_path__ + "img/bacaniaveche.d37eab18.jpeg";